import React, { useEffect } from 'react'

type UseOutsideClickProps = {
  ref: React.RefObject<HTMLElement>
  isOpen: boolean
  onOutsideClick: () => void
}

export default function useOutsideClick({
  ref,
  isOpen,
  onOutsideClick,
}: UseOutsideClickProps) {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (isOpen) {
          onOutsideClick()
        }
      }
    }

    const timeoutId = setTimeout(() => {
      document.addEventListener('click', handleClick, false)
    }, 0)

    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener('click', handleClick)
    }
  }, [isOpen, ref, onOutsideClick])
}
